<script>
import fadeInUp from '../components/animations/FadeInUp.vue';
import wordsUp from '../components/animations/WordsUp.vue';
import zoomIn from '../components/animations/ZoomIn.vue';
import modal from './modal.vue';
import plyr from '../blocks/video.vue';

export default {
    components: {
        fadeInUp,
        wordsUp,
        zoomIn,
        modal,
        plyr
    },

    data() {
        return {
            lightboxOpen: false
        };
    },

    mounted() {},

    methods: {}
};
</script>
